import { component } from 'picoapp';
import Glide from '@glidejs/glide';

export default component((node, ctx) => {
  const { productId, baseUrl, limit } = node.dataset;
  const isDesktop = ctx.getState().isDesktop.matches;

  const url = `${baseUrl}?section_id=product-recommendations&product_id=${productId}&limit=${limit}`;

  const init = () => {
    if (node.dataset.type == 'manual') {
      !isDesktop && initialiseCarousel();
    } else {
      fetchRecommendations();
    }
  };

  const initialiseCarousel = () => {
    const carousel = node.querySelector('.js-recommendations-carousel');
    const track = node.querySelector('.js-recommendations-track');
    const slidesContainer = node.querySelector('.js-product-recommendations-grid');
    const slides = node.querySelectorAll('.js-product-card');

    carousel.classList.add('glide');
    track.classList.add('glide__track');
    slidesContainer.classList.add('glide__slides');
    slides.forEach(slide => slide.classList.add('glide__slide'));

    const glide = new Glide(carousel, {
      type: 'carousel',
      startAt: 0,
      perView: 3,
      gap: 40,
      rewind: false,
      animationDuration: 400,
      breakpoints: {
        1200: {
          perView: 2,
        },
        768: {
          perView: 1
        }
      }
    });

    glide.mount();
  };

  const fetchRecommendations = () => {
    $.ajax({
      url,
      type: 'GET',
    })
      .done((data) => {
        $('.js-product-recommendations-grid').append($(data).find('.js-product-recommendations-grid').html());
        !isDesktop && initialiseCarousel();
      });
  };

  const observer = new MutationObserver(() => {
    ctx.emit('recommendations:updated');
    observer.disconnect();
  });

  observer.observe(node, {
    childList: true,
    subtree: true,
  });

  init();

});